import React from 'react'
import { Element } from 'react-scroll'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { TwoTitle } from '../atoms/two_title'
import { Image } from '../atoms/image'

export const ExampleView = () => {

  const cards: Array<{ imageName: string, title: string, name: string, description: string }> = [
    { imageName: "example2.jpg", title: "青山通り歯科", name: '矢島昇吾 院長', description: "他のマウスピース矯正と比べて、精密さや設計の自由度がかなり高いと思います。前歯しか動かせなかったり、精密さが物足りないブランドもある中で、hanaloveは信頼できるブランドだと感じています。" },
  ]

  const renderMethod = () => cards.map((card, index) => (
    <div className="exampleView--item">
      <div className="exampleView--item--imageArea">
        <Image imageName={card.imageName} className="exampleView--item--imageArea__image" />
      </div>
      <div className="exampleView--item--descriptionArea">
        <div className="exampleView--item--descriptionArea--titleArea">
          <p className="exampleView--item--descriptionArea--titleArea__title">{card.title}</p>
          <p className="exampleView--item--descriptionArea--titleArea__name">{card.name}</p>
        </div>
        <p className={`exampleView--item--descriptionArea__description`}>{card.description}</p>
      </div>
    </div>
  ))

  return (
    <Fade left duration={500} distance="40px">
      <section className="content">
        <Element name="page-example" className="exampleView">
          <TwoTitle jpnLabel='導入事例' engLabel='Introduction example' />
          <section className="exampleView--listArea exampleView--listArea__pc">
            {renderMethod()}
          </section>
          <Carousel
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            centerMode={true}
            emulateTouch={true}
            centerSlidePercentage={91}
            preventMovementUntilSwipeScrollTolerance={true}
            swipeScrollTolerance={100}
            className="exampleView--listArea exampleView--listArea__sp"
          >
            {renderMethod()}
          </Carousel>
        </Element>
      </section>
    </Fade>
  )
}
